(function() {
    'use strict';
    var EosCtrl = function ( $scope, $uibModalInstance) {
        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }
    }
    EosCtrl.$inject = ['$scope','$uibModalInstance'];
    angular.module('app').controller('EosCtrl',EosCtrl);
}());

